declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_with_separate_default_in_right_part_foo extends $mol_object {
		b( next?: boolean ): boolean
		a( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_with_separate_default_in_right_part_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_with_separate_default_in_right_part_foo['b'] >
	}
	
}

//# sourceMappingURL=bidi_with_separate_default_in_right_part.view.tree.d.ts.map